export default __webpack_public_path__ + "static/media/ho.4696a859.jpg";